var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tab-container',[_c('div',{attrs:{"slot":"operation"},slot:"operation"},[_c('a-range-picker',{staticStyle:{"width":"380px"},attrs:{"show-time":{
        defaultValue: [
          _vm.$moment('00:00:00', 'HH:mm:ss'),
          _vm.$moment('23:59:59', 'HH:mm:ss'),
        ],
      },"format":"YYYY-MM-DD"},on:{"ok":_vm.onChangeTimeRange,"change":_vm.initData}})],1),_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.tableData,"pagination":_vm.pagination,"row-key":record => record.pkId,"loading":_vm.loading,"scroll":{ x: 1200 }},on:{"change":_vm.handlePagination}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }